import { Component, Injector, OnInit } from "@angular/core"
import { Title } from "@angular/platform-browser"
import { ActivatedRoute, Params } from "@angular/router"
import { BrowsingService } from "../services/browsing.service"
import { FacetingService } from "../services/faceting.service"
import { EduComponent } from "../utils/eduComponent"
import { AddOnViewService } from "../services/add-on-view.service"
import { PreviousRouteService } from "../services/previous-route.service"
import { routeAnimations, routeTransition } from "../utils/animations"

@Component({
    templateUrl: "./search-page.component.html",
    styleUrls: ["./search-page.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class SearchPageComponent extends EduComponent implements OnInit {
    isAddonView: boolean

    constructor(
        public addOnService: AddOnViewService,
        private browsingService: BrowsingService,
        private facetingService: FacetingService,
        private route: ActivatedRoute,
        private titleService: Title,
        private injector: Injector
    ) {
        super()
        this.titleService.setTitle("Search Classroom Resources | PBS LearningMedia")
    }

    public ngOnInit() {
        const previousRouteService = this.injector.get(PreviousRouteService)
        this.route.queryParams.subscribe((queryParams) => {
            previousRouteService.currentQueryParams$.next(queryParams)
        })
        this.isAddonView = this.addOnService.isAddonView
        this.addSub(this.browsingService.getSubjectsTree().subscribe())
        this.addSub(
            this.route.queryParams.subscribe((queryParams: Params) =>
                this.facetingService.updateFacetsFromQueryParams(queryParams)
            )
        )
    }
}
